import axios from 'axios';

const DADATA_TOKEN = 'Token 0d79de414e70a03a38147fc945cf0a333ee871ec';
// const DADATA_SECRET = '3405f3b2a53814b5b68826b2b5bb1d3db3e55846';
const DADATA_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/bank';

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      middleName: '',
      account_number: '',
      bik: '',
      corr_account_number: '',
      bank_name: '',
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    valid() {
      return (
        this.account_number.length === 24 && this.bik.length === 9
        && this.corr_account_number.length === 20 && this.bank_name.length
      );
    },
  },
  methods: {
    setAccount() {
      this.firstName = this.user.first_name;
      this.lastName = this.user.last_name;
      this.middleName = this.user.middle_name;

      this.account_number = this.user?.current_bank_account?.account_number || '';
      this.bik = this.user?.current_bank_account?.bik || '';
      this.corr_account_number = this.user?.current_bank_account?.corr_account_number || '';
      this.bank_name = this.user?.current_bank_account?.bank_name || '';

      if (this.user?.current_bank_account?.bik) {
        this.fetchBankInfo();
      }
    },
    fetchBankInfo() {
      const body = { query: this.bik };
      const config = {
        headers: {
          Accept: 'application/json',
          Authorization: DADATA_TOKEN,
          // 'X-Secret': DADATA_SECRET,
          'Content-Type': 'application/json',
        },
      };
      axios.post(DADATA_URL, body, config)
        .then((res) => {
          const bank = res.data?.suggestions?.[0]?.data;
          if (bank) {
            this.bank_name = bank.name?.payment || '';
            this.bik = bank.bic;
            this.corr_account_number = bank.correspondent_account || '';
          }
        })
        .catch((err) => {
          console.error('fetchBankInfo error', err);
        });
    },
    onBikChange(e) {
      console.log(e);
    },
    onSubmit() {
      const app = this;
      const data = {
        first_name: app.firstName,
        last_name: app.lastName,
        middle_name: app.middleName,
        profile_id: app.user.profile_id,
        account_number: app.account_number,
        bik: app.bik,
        corr_account_number: app.corr_account_number,
        bank_name: app.bank_name,
      };

      if (this.valid && this.isAuthenticated) {
        app.$store.getters.axl.post('profiles/api/bank-accounts/save', data)
          .then(async () => {
            app.$store.dispatch('ShowInfo', 'Ваш счет был успешно обновлён');
            this.$store.dispatch('GetProfile');
            this.$router.push('/dashboard');
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
  },
  watch: {
    bik(val) { val && val.length === 9 && this.fetchBankInfo(); },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('GetProfile');
      this.setAccount();
    }
  },
};
